import {v4} from 'uuid';

export const generateUuid = () => v4();

export const generateRandomPhoneNumber = () => {
  const areaCode = 602;
  const centralOfficeCode = Math.floor(100 + Math.random() * 900); // Código central de 3 dígitos
  const lineNumber = Math.floor(1000 + Math.random() * 9000); // Número de línea de 4 dígitos
  return `+1${areaCode}${centralOfficeCode}${lineNumber}`;
};

export const generateRandomEmail = () => {
  const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com']; // Dominios comunes
  const randomName = Math.random().toString(36).substring(2, 10); // Nombre aleatorio
  const randomDomain = domains[Math.floor(Math.random() * domains.length)]; // Dominio aleatorio
  return `onbv3${randomName}@${randomDomain}`;
};
